import { Component, OnInit, NgZone } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthServiceService } from '../../core/http/auth-service.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Md5 } from 'ts-md5/dist/md5';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
  isLoading = false;
  loginErrors = null;
  data = null;
  mode = 'login';
  clicked = false;
  SignLoading = false;
  password;
  selected = 'Patient';
  role = localStorage.getItem('role');
  show = false;

  forgot() {
    this.mode = 'pass';
  }
  switch() {
    this.show = !this.show;
  }

  login() {
    this.mode = 'login';
  }

  loginForm = new FormGroup({
    userEmail: new FormControl('', Validators.required),
    refNo: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
    confirmPassword: new FormControl('', Validators.required),
  });

  constructor(
    public auth: AuthServiceService,
    public router: Router,
    private zone: NgZone,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute
  ) {}

  logins() {
    this.mode = 'login';
  }
  signup() {
    this.router.navigateByUrl('/');
  }

  submit() {
    this.SignLoading = true;
    console.log(this.loginForm.value);
    const { userEmail, refNo, password, confirmPassword } =
      this.loginForm.value;
    if (password !== confirmPassword) {
      this._snackBar.open(
        'please make sure your password match with confirm password',
        '',
        {
          duration: 2000,
          verticalPosition: 'top',
        }
      );
      return false;
    }
    this.auth
      .changePassword(userEmail, refNo, password, confirmPassword)
      .subscribe(
        (resSuccess: any) => {
          this.data = resSuccess;
          this.SignLoading = false;

          console.log('user object', this.data);
          if (resSuccess.isSuccessful) {
            this._snackBar.open('Password changed successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
            this.router.navigateByUrl('/login');
            this.loginForm.reset();
          } else {
            this._snackBar.open(resSuccess.hasError, '', {
              duration: 2000,
              verticalPosition: 'top',
            });
            this.isLoading = false;
          }
        },
        (resErr) => {
          this._snackBar.open(resErr, '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          this.SignLoading = false;
        }
      );
  }

  ngOnInit(): void {
    console.log(this.route.snapshot.paramMap.get('ref'));
    this.loginForm.patchValue({
      refNo: this.route.snapshot.paramMap.get('ref'),
    });
  }
}
